import { render } from "./WorkspaceSendingBanner.vue?vue&type=template&id=09ff3f50&scoped=true"
import script from "./WorkspaceSendingBanner.vue?vue&type=script&lang=js"
export * from "./WorkspaceSendingBanner.vue?vue&type=script&lang=js"

import "./WorkspaceSendingBanner.vue?vue&type=style&index=0&id=09ff3f50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ff3f50"]])

export default __exports__